import { closestCorners, DndContext, DragOverlay } from "@dnd-kit/core";
import { Box, Stack } from "@mui/material";
import { TextField, TextFieldProps } from "common";

import { ReactNode } from "react";
import Block from "./Block";
import FieldBase from "./FieldBase";
import { useFormEditor } from "./FormEditorDataProvider";
import { FieldType } from "./types";

function uniqueId() {
  return Math.floor(Math.random() * Date.now()).toString(16);
}
function defaultField() {
  return {
    id: uniqueId(),
    type: FieldType.text,
    name: "Text Field",
  };
}

type ArrayTextFieldProps = {} & TextFieldProps;
function ArrayTextField({ onChange, value, ...rest }: ArrayTextFieldProps) {
  function handleChange(evt: any) {
    if (evt.target.value) {
      onChange && onChange({ target: { value: evt.target.value.split("\n") } });
    } else {
      onChange && onChange({ target: { value: null } });
    }
  }
  const stringValue = Array.isArray(value)
    ? (value as any).join("\n")
    : undefined;
  return <TextField {...rest} onChange={handleChange} value={stringValue} />;
}

export interface FormProps {
  children?: ReactNode;
}
export type SelectionState = {
  rowIndex: number;
  fieldIndex: number;
};

export default function Form({ children }: FormProps) {
  const {
    handleDragEnd,
    handleDragStart,
    handleDragOver,
    sensors,
    value,
    draggingItem,
  } = useFormEditor();

  return (
    <Box sx={{ flex: 1 /*, paddingRight: 3*/ }}>
      {children}
      <Stack spacing={2}>
        <DndContext
          sensors={sensors}
          collisionDetection={closestCorners}
          onDragEnd={handleDragEnd}
          onDragStart={handleDragStart}
          onDragOver={handleDragOver}
        >
          {value &&
            value
              .filter(v => !Array.isArray(v))
              .map((block, blockIndex) => {
                //return JSON.stringify(row);
                return (
                  <Block blockIndex={blockIndex} key={block.id} block={block} />
                );
              })}
          <DragOverlay>
            {draggingItem ? (
              <FieldBase
                field={draggingItem.field}
                coordinates={draggingItem.originalCoordinates}
              />
            ) : null}
          </DragOverlay>
        </DndContext>
      </Stack>
    </Box>
  );
}
